import { Messages } from "@openreplay/tracker";
import { Encoder, murmur } from "./syncod-v2/index.js";
function processMutationAndState(app, options, encoder, mutation, state) {
    if (options.filter(mutation, state)) {
        try {
            const _mutation = encoder.encode(options.mutationTransformer(mutation));
            const _state = encoder.encode(options.transformer(state));
            const _table = encoder.commit();
            for (let key in _table)
                app.send(Messages.OTable(key, _table[key]));
            app.send(Messages.Zustand(_mutation, _state));
        }
        catch (e) {
            encoder.clear();
            app.debug.error(e);
        }
    }
}
const createZustandTracker = (opts = {}) => {
    const options = Object.assign({
        filter: () => true,
        transformer: state => state,
        mutationTransformer: mutation => mutation
    }, opts);
    return (app) => {
        if (app === null) {
            return f => (set, get, api) => f(set, get, api);
        }
        const encoder = new Encoder(murmur, 50);
        const state = {};
        return (f, name = Math.random()
            .toString(36)
            .substring(2, 9)) => (set, get, api) => {
            const loggedSet = (...args) => {
                set(...args);
                state[name] = get();
                processMutationAndState(app, options, encoder, args.map(a => { var _a, _b; return (a ? (_b = (_a = a.toString) === null || _a === void 0 ? void 0 : _a.call(a)) !== null && _b !== void 0 ? _b : "" : ""); }), state);
            };
            return f(loggedSet, get, api);
        };
    };
};
export default createZustandTracker;
